export const thresholdConfigConsts = {
    title: 'Time-in-Status Threshold Configuration',
    statusColumnLabel: 'Work Order Status',
    daysColumnLabel: 'Days Threshold',
    saveLabel: 'Save',
    legendTitle: 'Threshold Tiers',
    emptyStateLabel: 'No configurable statuses.',
    saveSuccessLabel: 'Thresholds saved successfully',
    saveErrorLabel: 'Failed to save thresholds',
    loadErrorLabel: 'Failed to load thresholds',
    readonlyTooltip: 'You do not have permission to edit thresholds',
};

export const thresholdLegendTiers = [
    {
        key: 'within',
        label: 'Within Threshold',
        description: 'Less than 70% of the configured threshold has elapsed',
    },
    {
        key: 'approaching',
        label: 'Approaching Threshold',
        description: '70–99% of the configured threshold has elapsed',
    },
    {
        key: 'breached',
        label: 'Threshold Breached',
        description: '100% or more of the configured threshold has elapsed',
    },
];
